import TxpImages from 'txp-data/lib/schema/configSchema/TxpImages';

export default function getTxpLocationIcon(txpImages: TxpImages) {
    return txpImages && txpImages.detailsIcons && txpImages.detailsIcons.location
        ? txpImages.detailsIcons.location
        : null;
}
